module.exports = __webpack_public_path__ + "img/empty.9e6c6f15.9e6c6f15.png";